export enum DataChangeStatus {
  PENDING_REVIEW = 'PENDING_REVIEW',
  REVIEWED = 'REVIEWED',
  IMPLEMENTED = 'IMPLEMENTED',
  UNKNOWN = 'UNKNOWN',
}
